module.exports = __webpack_public_path__ + "static/media/win-reward-A06.aaa31d25.png";